module.exports = __webpack_public_path__ + "static/media/manu-15.9dc8e4b7.png";